/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from '@salesforce/retail-react-app/app/components/shared/ui'
import { useUnavailableProductsInCartContext } from '../../../contexts/unavailable-products-in-cart-context'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

import { sendClickEvent } from '../../../utils/gtm-utils'
import { EswCheckoutBtn } from '../../../esw/components/checkout-btn'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import { useCurrentBasket } from '@salesforce/retail-react-app/app/hooks/use-current-basket'

const CartCta = () => {
    const navigate = useNavigation()
    const { UnavailableProductsInCart, unavailableProductIdsRef } =
        useUnavailableProductsInCartContext()
    const { locale } = useMultiSite()
    const { data: basket } = useCurrentBasket()

    const handleClick = () => {
        if (unavailableProductIdsRef.current?.length > 0) {
            UnavailableProductsInCart.onOpen()
        } else {
            // GTM Modification
            sendClickEvent('checkout_now_clicked')
            navigate('/checkout')
        }
    }

    return (
        <>
            <Fragment>
                {locale.isSupportedByESW ?
                    <EswCheckoutBtn variant="solid" basketIdParam={basket?.basketId} checkOrderAble={false} /> :
                    <Button
                        width={'full'}
                        variant="solid"
                        onClick={handleClick}
                        data-testid="cart-checkout-button"
                    >
                        <FormattedMessage id="cart_cta.checkout_button" defaultMessage="Checkout" />
                    </Button>}
            </Fragment>
        </>
    )
}

export default CartCta
